export const AGE_RANGES = ['5-9yrs', '8-12yrs', '9-Adult'];
export const SHAPE_OPTIONS = ['Cat-Eye', 'Round', 'Rectangular'];
export const WIDTH_OPTIONS = ['Extra-Narrow', 'Narrow', 'Medium', 'Wide', 'Extra-Wide'];
